import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Route, Routes } from "react-router-dom";
import useEffectLocation from "../hooks/useEffectLocation";
import "./style.scss";

const MainPage  = React.lazy(() => import("../views/home/Homy"));
const Work      = React.lazy(() => import("../views/Work"));
const SlugPage  = React.lazy(() => import("../views/portfolio/[slug]"));
const Contact   = React.lazy(() => import("../views/Contact"));

const Router = () => {
  const [transPage, setTransPage] = useState("in");
  const scrollbar = useSelector(state => state.scrollbar);
  const location  = useEffectLocation(() => setTransPage("out"));

  const onAnimateEnd = () => {
    if (transPage !== "out") return;
    scrollbar.current?.scrollTo(0, 0, 0);
    window.scrollTo(0, 0);
    setTransPage("in");
  };

  return (
    <div
      id="dsn-content"
      className={`dsn-transition-page dsn-animate-${transPage}`}
      onAnimationEnd={onAnimateEnd}
    >
      <Routes location={location}>
        <Route
          path="/"
          element={
            <React.Suspense fallback={<div className="background-main h-100-v" />}>
              <MainPage />
            </React.Suspense>
          }
        />

        <Route
          path="/portfolio"
          element={
            <React.Suspense fallback={<div>Loading portfolio…</div>}>
              <Work />
            </React.Suspense>
          }
        />

        <Route
          path="/portfolio/:slug"
          element={
            <React.Suspense fallback={<div>Loading project…</div>}>
              <SlugPage />
            </React.Suspense>
          }
        />

        <Route
          path="/contact"
          element={
            <React.Suspense fallback={<div>Loading contact…</div>}>
              <Contact />
            </React.Suspense>
          }
        />

        <Route path="*" element={<h1>Not Found</h1>} />
      </Routes>
    </div>
  );
};

export default React.memo(Router);
